import { Adapter } from './adapter';
import { Testimonial } from '../models/_index';
import { TestimonialInterface } from '@app/interfaces/_index';
import { TestimonialViewTypes } from '@app/enums/_index';

/**
 * Adapts raw testimonial CMS object to a Testimonial Model
 * NOTE: The item fields are the default json property names.
 */
export class TestimonialAdapter implements Adapter<Testimonial> {
  /**
   * Adapt data item into a Testimonial model.
   * @param item - data item to be transformed adapted to a Testimonial model
   * @returns - returns an adapted Testimonial model
   */
  adapt(item: TestimonialInterface): Testimonial {
    let testimonial: Testimonial;
    if (item) {
      testimonial = new Testimonial(
        item.acf.title,
        item.acf.quote,
        item.acf.author,
        item.acf.icon,
        item.acf.icon_name,
        item.acf.job_title,
        item.acf.company,
        item.acf.view,
        item.acf.external_url,
        item.acf.external_link_cta
      );
    }
    return testimonial;
  }

  /**
   * Adapt data item into a Testimonial model by filtering the view type first.
   * @param item - data item to be transformed adapted to a Testimonial model
   * @param viewType - filter testimonials by a view type
   * @returns - returns an adapted Testimonial model, else return an unmatched null.
   */
  filter(item: TestimonialInterface, viewType: TestimonialViewTypes): Testimonial {
    if (item && item?.acf?.view === viewType) {
      return this.adapt(item);
    }
    return null;
  }
}
